import { render, staticRenderFns } from "./PricingTableSheet.vue?vue&type=template&id=058088d8&scoped=true&"
import script from "./PricingTableSheet.vue?vue&type=script&lang=js&"
export * from "./PricingTableSheet.vue?vue&type=script&lang=js&"
import style0 from "./PricingTableSheet.vue?vue&type=style&index=0&id=058088d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058088d8",
  null
  
)

export default component.exports